import React from "react";
import styled from "styled-components";
import MuiFormControl from "@material-ui/core/FormControl";

export const FormControl = styled(({ disableMargin, ...props }) => <MuiFormControl {...props} />)<{
    flex?: number;
    disableMargin?: boolean;
}>`
    flex: ${({ flex = 1 }) => flex};
    margin-right: ${({ theme, disableMargin = false }) => (disableMargin ? 0 : theme.spacing(4))}px;
    position: relative;
    justify-content: flex-start;
    padding-bottom: ${({ theme }) => theme.spacing(1)}px;
`;
